module.exports = __webpack_public_path__ + "img/hair-lg.f4253f16.png";